module.exports = __webpack_public_path__ + "img/gsyjbg.e3315726.png";